// extracted by mini-css-extract-plugin
export default {"tabsStyle":"tab_tabsStyle__kCt4L","tabsStyleActive":"tab_tabsStyleActive__TWRI5","tabsStyleEmpty":"tab_tabsStyleEmpty__9KmUw","tabsStyleFull":"tab_tabsStyleFull__lQM7t"};